import { jsx as _jsx } from "react/jsx-runtime";
const InfoCircleFull = () => (_jsx("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "m32 2a30 30 0 1 0 30 30 30 30 0 0 0 -30-30zm3 45h-6v-18h6zm0-24h-6v-6h6z" }) })));
export default InfoCircleFull;
